/**
 * Validates if a timezone is valid
 * @param {string} tz Timezone string
 * @returns {Boolean} True if valid, false otherwise
 */
const isValidTimezone = (tz) => {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch (ex) {
    return false;
  }
};

module.exports = {
  isValidTimezone,
};
